'use strict';
import isFunction from 'lodash/isFunction';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as FlipMoveConfig from '../../../config/style/FlipMoveListConfig';
import {StatusOverlayComponent} from '../../../core-components/loading-icon/components/StatusOverlayComponent';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {ActiveTimerItem} from '../ActiveTimerItem';

export class ActiveTimerListComponent extends Component {
  static propTypes = {
    taskId: T.string,
    showNoDataIcon: T.bool,
    canScroll: T.bool,

    // i18n messages
    placeholderTitle: T.string,
  };

  static defaultProps = {
    // i18n messages
    placeholderTitle: 'No active timers.',

    init: false,
  };

  static scrollStyle = {overflowX: 'hidden', overflowY: 'scroll'};
  static defaultStyle = {};

  constructor(props) {
    super(props);

    this.handleStartTimer = this.handleStartTimer.bind(this);
    this.handlePauseTimer = this.handlePauseTimer.bind(this);
    this.handleStopTimer = this.handleStopTimer.bind(this);
  }

  handleStartTimer(e, model) {
    if (isFunction(this.props.onStartTimer)) {
      this.props.onStartTimer(model);
    }
  }

  handlePauseTimer(e, model) {
    if (isFunction(this.props.onPauseTimer)) {
      this.props.onPauseTimer(model);
    }
  }

  handleStopTimer(e, model) {
    if (isFunction(this.props.onStopTimer)) {
      this.props.onStopTimer(model);
    }
  }

  render() {
    return (
      <div className={this.props.wrapperClassName}>
        <StatusOverlayComponent
          overlayClassName={this.props.overlayClassName}
          mode={this.props.mode}
          showNoDataIcon={this.props.showNoDataIcon}
          noDataLabel={this.props.placeholderTitle}
        />
        <div
          className={classNames({
            'activity-feed-scroll-panel': this.props.canScroll,
          })}
          style={this.props.canScroll ? ActiveTimerListComponent.scrollStyle : ActiveTimerListComponent.defaultStyle}
        >
          <div>
            <ReactCSSTransitionGroup
              transitionName={FlipMoveConfig.transitionName}
              transitionAppear={FlipMoveConfig.transitionAppear}
              transitionAppearTimeout={FlipMoveConfig.transitionAppearTimeout}
              transitionEnterTimeout={FlipMoveConfig.transitionEnterTimeout}
              transitionLeaveTimeout={FlipMoveConfig.transitionLeaveTimeout}
              className="list"
            >
              {this.props.list ? this.props.list.map(model => (
                <ActiveTimerItem
                  key={getKey(model, this.props.userId)}
                  className={this.props.itemClassName}
                  itemId={getId(model)}
                  userId={this.props.userId}
                  model={model}
                  onClick={this.props.onClickItem}
                  onContextMenu={this.props.onItemContextMenu}
                  onClickStart={this.handleStartTimer}
                  onClickPause={this.handlePauseTimer}
                  onClickStop={this.handleStopTimer}
                />
              )) : null}
            </ReactCSSTransitionGroup>
          </div>
        </div>
      </div>
    );
  }
}

export function getKey(model, userId) {
  if (model.requestId && (!model.user || model.user === userId)) {
    return model.requestId;
  } else {
    return model.id;
  }
}



// WEBPACK FOOTER //
// ./src/js/timers/components/ActiveTimerList/ActiveTimerListComponent.js